import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { ALTS_COLORS } from "@/utils/colors";
import { useIsMobile } from "@/hooks/use-mobile";

interface AltsChartProps {
  chartData: {
    name: string;
    value: number;
    isHidden: boolean;
  }[];
  colors: string[];
}

const AltsChart = ({ chartData, colors }: AltsChartProps) => {
  const isMobile = useIsMobile();
  const chartSize = isMobile ? 280 : 300; // Reduced desktop size from 350 to 300

  return (
    <PieChart 
      width={chartSize} 
      height={chartSize}
      margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
    >
      <Pie
        data={chartData}
        cx="50%"
        cy="50%"
        innerRadius={chartSize * 0.2}
        outerRadius={chartSize * 0.3}
        paddingAngle={2}
        dataKey="value"
        nameKey="name"
        startAngle={90}
        endAngle={-270}
      >
        {chartData.map((entry, index) => {
          const colorIndex = index % colors.length;
          return (
            <Cell 
              key={`cell-${index}`}
              fill={entry.isHidden ? "#ffffff" : colors[colorIndex]}
              stroke={entry.isHidden ? colors[colorIndex] : "white"}
              strokeWidth={2}
            />
          );
        })}
      </Pie>
      <Tooltip 
        formatter={(value: number) => `${value}%`}
      />
    </PieChart>
  );
};

export default AltsChart;